import * as actions from "../../actions/tagColor";

const initialState = {
  items: [],
  loading: false,
  errors: {},
  pages: null,
  filter: []
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.SET_VALUE: {
      return {
        ...state,
        ...payload
      };
    }
    case actions.CLEAR_VALUE: {
      return {
        ...state,
        ...initialState
      };
    }
    case actions.GET_TAG_COLORS: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_TAG_COLORS_FAILED: {
      return {
        ...state,
        errors: payload,
        loading: false
      };
    }
    case actions.GET_TAG_COLORS_SUCCESS: {
      return {
        ...state,
        items: payload || [],
        loading: false
      };
    }
    case actions.DELETE_TAG_COLOR: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.DELETE_TAG_COLOR_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.DELETE_TAG_COLOR_SUCCESS: {
      return {
        ...state,
        items: payload || [],
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
